<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      {{'play_conf_popup_title' | GetLabelPipe}}
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="overflow: hidden; display: flex !important; min-height: 300px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>
      <div *ngIf="state==='edit'">
        <br>
        <div style="margin: 20px 0px; font-size: 0.8em;" [innerHTML]="'play_conf_popup_description'|GetLabelPipe">
        </div>
        <fieldset>
          <legend style="font-size: 0.85em; font-weight: 500;">{{'play_able_weekdays'|GetLabelPipe}}</legend>
          <div>
            <div style="margin: 14px 0px">
              <mat-slide-toggle [checked]="weekday_morning" (toggleChange)="weekday_morning = !weekday_morning">
                {{'play_able_morning'|GetLabelPipe}}
              </mat-slide-toggle>
            </div>
            <div style="margin: 14px 0px">
              <mat-slide-toggle [checked]="weekday_day" (toggleChange)="weekday_day = !weekday_day">
                {{'play_able_day_middle'|GetLabelPipe}}
              </mat-slide-toggle>
            </div>
            <div style="margin: 14px 0px">
              <mat-slide-toggle [checked]="weekday_evening" (toggleChange)="weekday_evening = !weekday_evening">
                {{'play_able_evening'|GetLabelPipe}}
              </mat-slide-toggle>
            </div>
          </div>
        </fieldset>
        <br>
        <fieldset>
          <legend style="font-size: 0.85em; font-weight: 500;">{{'play_able_weekends'|GetLabelPipe}}</legend>
          <div>
            <div style="margin: 14px 0px">
              <mat-slide-toggle [checked]="weekend_morning" (toggleChange)="weekend_morning = !weekend_morning">
                {{'play_able_morning'|GetLabelPipe}}
              </mat-slide-toggle>
            </div>
            <div style="margin: 14px 0px">
              <mat-slide-toggle [checked]="weekend_day" (toggleChange)="weekend_day = !weekend_day">
                {{'play_able_day_middle'|GetLabelPipe}}
              </mat-slide-toggle>
            </div>
            <div style="margin: 14px 0px">
              <mat-slide-toggle [checked]="weekend_evening" (toggleChange)="weekend_evening = !weekend_evening">
                {{'play_able_evening'|GetLabelPipe}}
              </mat-slide-toggle>
            </div>
          </div>
        </fieldset>
      </div>
      <br>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'cancel'|GetLabelPipe}}
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent"
              (click)="handleSubmit()" [disabled]="state === 'loading'">
        {{'save'|GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
